// operation panel will show the element icon in add-element list and treeview

export const iconMap = {
  box: "mdi-square-rounded-outline",
  table: "mdi-table",
  tcol: "mdi-view-column-outline",
  trow: "mdi-table-column",
  text: "mdi-alpha-t-box",
  checkbox: "mdi-checkbox-marked",
  textField: "mdi-keyboard",
  icon: "mdi-star",
  select: "mdi-arrow-down-drop-circle",
  datePicker: "mdi-calendar",
  textarea: "mdi-card-text",
  radioGroup: "mdi-circle-multiple",
  radio: "mdi-radiobox-marked",
  multiSelect: "mdi-checkbox-multiple-marked",
  timeIntervalSelect: "mdi-clock-time-eight",
  imageUploader: "mdi-image-plus",
  separator: "mdi-minus-thick",
  chipGroup: "mdi-checkbox-multiple-blank",
  chip: "mdi-square-rounded",
};

export default {
  box: "mdi-square-rounded-outline",
  table: "mdi-table",
  tcol: "mdi-view-column-outline",
  trow: "mdi-table-column",
  text: "mdi-alpha-t-box",
  checkbox: "mdi-checkbox-marked",
  textField: "mdi-keyboard",
  icon: "mdi-star",
  select: "mdi-arrow-down-drop-circle",
  datePicker: "mdi-calendar",
  textarea: "mdi-card-text",
  radioGroup: "mdi-circle-multiple",
  radio: "mdi-radiobox-marked",
  multiSelect: "mdi-checkbox-multiple-marked",
  timeIntervalSelect: "mdi-clock-time-eight",
  imageUploader: "mdi-image-plus",
  separator: "mdi-minus-thick",
  chipGroup: "mdi-checkbox-multiple-blank",
  chip: "mdi-square-rounded",
};
